module.exports = __webpack_public_path__ + "img/grupa_zir.cdc78d78.png";